import React from 'react';
import glometal from "../images/glometal-logo.PNG";
import FaIcon from '../utils/FaIcon';

const Footer = () => {
    return (
        <footer className="footer-panel">
            <div className="footer-card">
                <img src={glometal} alt="Glometal Logo" className="footer-logo"/>
            </div>
            <div className="footer-card">
                <h2>Contact Us</h2>
                <p><FaIcon icon='envelope' color="#fff"/><a href='mailto:info@glometal.in'>info@glometal.in</a></p>
                <p><FaIcon icon='phone' color="#fff"/><a href='tel:+919008688888'>+91 90086 88888</a>, <a href='tel:+91990066219'>+91 9900 66219</a></p>
                <p><FaIcon icon='map-marker-alt' color="#fff"/><a href='https://maps.app.goo.gl/qzNzBJmMjfz6SASk8' target='_blank'>Sy.No. 36, Plot No: 68B, Road No-18, Phase-1, KIADB Industrial Area, Masthenhalli, Kaiwara, Taluk: Chintamani, PIN: 562102</a></p>
            </div>
            <div className="footer-card">
                <h2>Quick Links</h2>
                <p>
                    <a href='/'>
                        Home
                    </a> | <a href='/about'>
                        About
                    </a> | <a href='/cable-trays/universal'>
                        Cable Trays
                    </a> | <a href='/modular-boxes'>
                        Modular Boxes
                    </a> | <a href='contact'>
                        Contact
                    </a>
                </p>
            </div>
            <div className="footer-card">
                <p><FaIcon isRegIcon={true} icon='copyright' color="#fff"/> {new Date().getFullYear()} Glometal. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;